import React from 'react'

const SvgCalendarWithDropFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M17.505 10.702a.452.452 0 00-.595.123c-.215.321-.463.658-.76 1.056-1.307 1.775-3.258 4.454-3.258 5.984 0 1.118.496 2.128 1.29 2.863a4.605 4.605 0 003.092 1.178c1.207 0 2.298-.46 3.092-1.194s1.29-1.745 1.29-2.862c0-1.53-1.951-4.194-3.258-5.97a67.575 67.575 0 01-.76-1.055.486.486 0 00-.133-.123zM5 4H4c-1.333 0-2 .668-2 2.004V8h16V6c0-1.333-.667-2-2-2h-1V2.941C15 2.314 14.667 2 14 2s-1 .314-1 .941V4H7.004V3c0-.667-.334-1-1.004-1-.67 0-1.002.333-1 1v1z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.335 22H4c-1.333 0-2-.667-2-2V10h13.646a64.64 64.64 0 00-2.156 3.082A1.32 1.32 0 0013 13h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1h.353c-.391.744-.695 1.455-.85 2.084-.335.138-.502.443-.503.916 0 .466.162.768.486.909.223 1.136.824 2.151 1.672 2.937.058.052.117.104.177.154zM8 15H7c-.667.001-1-.332-1-1 .001-.668.335-1.001 1.002-1H8c.667 0 1 .333 1 1s-.333 1-1 1zm0 4H7c-.667.001-1-.332-1-1 .001-.668.335-1.001 1.002-1H8c.667 0 1 .333 1 1s-.333 1-1 1z'
    />
  </svg>
)

export default SvgCalendarWithDropFilled
